import { Button, withStyles } from '@material-ui/core';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import type { RouteComponentProps } from 'react-router-dom';
import type VideoStore from 'tm3-core/controls/video/store';
import styles from './styles';
interface IProps extends RouteComponentProps<{ appointmentId: string }> {}
import { DateLabel, TimeLabel } from 'bz-core-controls';
import cx from 'classnames';
import { action, computed, observable } from 'mobx';
import moment from 'moment';
interface IProps {
  videoStore?: VideoStore;
}
@inject('videoStore')
@observer
class JoinOptions extends Component {
  private interval: any;
  @observable now: moment;

  componentDidMount() {
    this.now = moment();
    this.interval = setInterval(() => (this.now = moment()), 120000);
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    const { startDateTime, practitionerName, joinNow, callEnded } = this.props.videoStore;
    const {
      classes: { button },
      videoId
    } = this.props;

    let header = 'Your video consultation is ready to start';
    let detail = <div />;
    let joinEnabled = false;
    let hideButton = false;
    if (callEnded) {
      header = 'Thank you for joining the video consultation';
      detail = <div>You have now finished the call.</div>;
      hideButton = true;
    } else if (this.consultationNotReady) {
      header = 'The video consultation is not ready to start.';
      detail = (
        <div>
          <p>
            Your appointment is with {practitionerName} and starts on{' '}
            <DateLabel value={startDateTime} /> at <TimeLabel value={startDateTime} />
          </p>
        </div>
      );
    } else if (this.consultationPast) {
      header = 'This appointment is in the past, and can no longer be joined';
      hideButton = true;
    } else {
      header = 'Your video consultation is ready to start';
      detail = (
        <p>
          Your appointment is with {practitionerName} and starts on{' '}
          <DateLabel value={startDateTime} /> at <TimeLabel value={startDateTime} />
        </p>
      );
      joinEnabled = true;
    }

    return (
      <div>
        <h3>{header}</h3>
        {detail}
        {!hideButton && (
          <Button
            disabled={!joinEnabled}
            className={button}
            onClick={() => joinNow(videoId, true, true)}
          >
            Join Call
          </Button>
        )}
      </div>
    );
  }

  @computed
  get consultationNotReady() {
    const start = moment(this.props.videoStore.startDateTime);
    return this.now <= start.subtract(5, 'minutes');
  }

  @computed
  get consultationPast() {
    const end = moment(this.props.videoStore.endDateTime);
    return this.now > end.add(10, 'minutes');
  }
}

export default withStyles(styles)(JoinOptions);
